import * as React from "react";
import ReactDOM from "react-dom";
import { withDefault } from "collection-utils";

import { nonNull } from "common/Support";
import { TooltipStyle, Position } from "./tooltip-style";
import debounce from "lodash/debounce";

interface Props {
    show?: boolean;
    target: React.RefObject<any>;
    width?: number;
    position?: Position;
    longWord?: boolean;
    zIndex?: number;
}

interface State {
    visible: boolean;
    bounds?: ClientRect | DOMRect;
    listenersAttached: boolean;
}

export class Tooltip extends React.Component<Props, State> {
    public state: State = {
        visible: false,
        bounds: undefined,
        listenersAttached: false,
    };

    public componentDidUpdate() {
        if (!this.state.listenersAttached) {
            this.addEventsToTarget();
        }
        this.updateBounds();
    }

    public componentDidMount() {
        this.addEventsToTarget();
        this.updateBounds();
    }

    public componentWillUnmount() {
        this.removeEventsToTarget();
    }

    private onMouseEnter = () => {
        this.setState({ visible: true });
        this.updateBoundsReal();
    };

    private onMouseLeave = () => {
        this.setState({ visible: false });
    };

    private addEventsToTarget = () => {
        const { target } = this.props;
        const node = ReactDOM.findDOMNode(target.current);
        if (node !== null && node instanceof Element) {
            node.addEventListener("mouseenter", this.onMouseEnter);
            node.addEventListener("mouseleave", this.onMouseLeave);
            this.setState({ listenersAttached: true });
        }
    };

    private removeEventsToTarget = () => {
        const { target } = this.props;
        const node = ReactDOM.findDOMNode(target.current);
        if (node !== null && node instanceof Element) {
            node.removeEventListener("mouseenter", this.onMouseEnter);
            node.removeEventListener("mouseleave", this.onMouseLeave);
        }
    };

    private updateBoundsReal = () => {
        const { target } = this.props;
        const node = ReactDOM.findDOMNode(target.current);
        if (node !== null && node instanceof Element) {
            const bounds = node.getBoundingClientRect();
            if (
                this.state.bounds === undefined ||
                bounds.left !== this.state.bounds.left ||
                bounds.right !== this.state.bounds.right ||
                bounds.top !== this.state.bounds.top ||
                bounds.bottom !== this.state.bounds.bottom
            ) {
                this.setState({ bounds });
            }
        }
    };

    private updateBoundsDebounced = debounce(this.updateBoundsReal, 300);

    private updateBounds(): void {
        this.updateBoundsDebounced();
    }

    public render() {
        const { show, width, position, longWord, zIndex } = this.props;
        const visible = this.state.visible;
        const isLongWord = longWord !== undefined && longWord;

        let bounds = this.state.bounds;
        if (bounds === undefined || bounds.top === 0) {
            bounds = { left: 0, top: 0, right: 0, bottom: 0, width: 0, height: 0 };
            if (visible) {
                this.setState({ visible: false });
            }
        }

        // TODO: Something
        if (!document.getElementById("portal")) {
            const portal = document.createElement("div");
            portal.setAttribute("id", "portal");
            document.body.appendChild(portal);
        }

        return ReactDOM.createPortal(
            <TooltipStyle
                visible={visible && show !== false}
                bounds={bounds}
                width={withDefault(width, 280)}
                position={withDefault(position, "right")}
                longWord={isLongWord}
                zIndex={zIndex}>
                {this.props.children}
            </TooltipStyle>,
            nonNull(document.getElementById("portal"))
        );
    }
}
